<template>
  <main>
    <Trail
      :list="[
        {
          name: 'Facility',
          path: `/facilidad/${facility.slug}/acerca-de`,
          tag: `${facility.title}`
        },
        {
          name: 'Facility',
          tag: `${currentSection.title}`
        }
      ]"
    />
    <Container class="container--main">
      <Row>
        <ColumnUi md="9">
          <Title tag="h1">{{ currentSection.title }}</Title>
          <component :is="component" />
        </ColumnUi>
        <ColumnUi md="3">
          <h3>En esta sección</h3>
          <List marked>
            <li v-for="(section, index) in sections" :key="index">
              <router-link
                v-if="currentSection.slug != section.slug"
                :to="`/facilidad/${facility.slug}/${section.slug}`"
              >
                {{ section.title }}
              </router-link>
              <span v-else>
                {{ section.title }}
              </span>
            </li>
          </List>
          <div class="contact" v-if="$route.path === '/facilidad/microfisica'">
            <h3>Contacto</h3>
            <div class="contact--item">
              <IconPerson />
              {{ facility.contact.name }}
            </div>
            <div class="contact--item">
              <IconEmail />
              <div>
                <template
                  v-for="(email, index) in facility.contact.email"
                  :key="index"
                >
                  <a :href="`mailto:${email}`">
                    {{ email }}
                  </a>
                  <template v-if="index + 1 < facility.contact.email.length">
                    {{ ", " }}
                  </template>
                </template>
              </div>
            </div>
            <div class="contact--item">
              <IconPhone />
              {{ facility.contact.phone }} Anexo
              {{ facility.contact.annex }}
            </div>
          </div>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import { getFacilities } from "@/facilities.js";
import Container from "@/components/ui/objects/Container";
import List from "@/components/ui/objects/List.vue";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import Title from "@/components/ui/atoms/Title.vue";
import dinamicaAbout from "@/components/facility/dinamica/About";
import dinamicaModeling from "@/components/facility/dinamica/Modeling";
// import dinamicaCluster from "@/components/facility/dinamica/Cluster";
// import dinamicaResources from "@/components/facility/dinamica/Resources";
import dinamicaPublications from "@/components/facility/dinamica/Publications";
import microfisicaAbout from "@/components/facility/microfisica/About";
import microfisicaInstruments from "@/components/facility/microfisica/Instruments";
import microfisicaMonitoring from "@/components/facility/microfisica/Monitoring";
import microfisicaResources from "@/components/facility/microfisica/Resources";
import microfisicaPublications from "@/components/facility/microfisica/Publications";
import IconPerson from "@/components/ui/icons/IconPerson";
import IconEmail from "@/components/ui/icons/IconEmail";
import IconPhone from "@/components/ui/icons/IconPhone";
import { useRoute } from "vue-router";

export default {
  components: {
    Trail,
    Container,
    Row,
    ColumnUi,
    List,
    Title,
    dinamicaAbout,
    dinamicaModeling,
    // dinamicaCluster,
    //dinamicaResources,
    dinamicaPublications,
    microfisicaAbout,
    microfisicaInstruments,
    microfisicaMonitoring,
    microfisicaResources,
    microfisicaPublications,
    IconPerson,
    IconEmail,
    IconPhone
  },
  setup() {
    const route = useRoute();
    const facility = getFacilities(process.env.VUE_APP_PREFIX)[
      route.params.facility
    ];
    const sections = facility.sections;
    const currentSection =
      facility.sections.find(section => section.slug == route.params.section) ||
      facility.sections[0];
    const component = `${route.params.facility}${currentSection.name}`;
    return {
      facility,
      sections,
      currentSection,
      component
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.contact {
  &--item {
    display: grid;
    grid-template-columns: 25px auto;
    flex-wrap: wrap;
    margin: 0;
  }
  svg {
    margin-top: 0.4em;
  }
}
</style>
